import {
    EditFieldInterface,
    FilterSize,
} from 'components/interfaces/GeneralInterface';
import { FieldTypeApiEnum } from 'submodules/api_middleware';

export const ROW_BREAK: EditFieldInterface = {
    type: FieldTypeApiEnum.BREAK,
    value: undefined,
    name: undefined,
    label: undefined,
    size: FilterSize.FULL,
};
